export default __webpack_public_path__ + "static/media/1.c4c95611.png";